import React, { ReactNode } from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as InfoIcon } from "src/images/info-new.svg";
import { ReactComponent as LoaderDots } from "src/images/loader-dots.svg";

import AudienceOverlapInfoState from "./AudienceOverlapInfoState";

interface Props {
  text: ReactNode;
  onRetry?: () => void;
}

export function AudienceOverlapLoadingState() {
  return (
    <AudienceOverlapInfoState
      icon={<LoaderDots />}
      title={
        <IDHFormattedMessage
          id="ws_analyzing_audience_overlap"
          defaultMessage="Analyzing audience overlap..."
        />
      }
      text={
        <IDHFormattedMessage
          id="front_audience_overlap_please_wait_message"
          defaultMessage="It may take a while..."
        />
      }
    />
  );
}

export default function AudienceOverlapEmptyState({ text, onRetry }: Props) {
  return (
    <AudienceOverlapInfoState
      icon={<InfoIcon />}
      title={
        <IDHFormattedMessage
          id="ws_no_audience_data_yet"
          defaultMessage="No audience data yet"
        />
      }
      text={text}
    >
      {onRetry && (
        <Button
          size="medium"
          variant="white-with-grey-border"
          onClick={onRetry}
          dataQa="audience-overlap-try-again-button"
        >
          <IDHFormattedMessage id="ws_try_again" defaultMessage="Try again" />
        </Button>
      )}
    </AudienceOverlapInfoState>
  );
}
